// extracted by mini-css-extract-plugin
export default {"SearchForm":"SearchForm_SearchForm__zvMFz"};